// Atomic component for displaying website links
export function WebsiteLink({ row }) {
  const { website } = row.original;

  if (!website) {
    return "";
  }

  const formattedUrl = website.startsWith("http")
    ? website
    : `https://${website}`;

  return (
    <a
      href={formattedUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="hover:underline flex items-center gap-1"
    >
      {website}
    </a>
  );
}
